import axios from "@/libs/api.request";

export const getNoticesList = filterCond => {
  return axios.request({
    url: "notices/getNoticesList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};

export const storeNoticesData = data => {
  return axios.request({
    url: "notices/storeNoticesData",
    data: data,
    method: "post"
  });
};

export const removeNoticeData = id => {
  return axios.request({
    url: "notices/removeNoticeData",
    data: { id },
    method: "post"
  });
};
